import React from "react";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import { useForm } from "react-hook-form";

const CategoryModal = (props) => {

  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {categoryName: props.category.overrideCategoryName},
  });

  const onSubmit = async (data) => {
    console.log("Category Modal Data:", data, props.category);
    props.updateCategoryName({...props.category, ...data});
  }

  const modalClose = () => {
    props.closeModal(false);
  }
console.log("Category Modal:", props.category);

  return (
    <Modal show={props.show} onHide={modalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Update Category Name<br/></Modal.Title>
    </Modal.Header>
    <Form onSubmit={handleSubmit(onSubmit)}>
    <Modal.Body>
      <div>Original Name: <span style={{fontWeight: 'bold' }}>{props.category.categoryName}</span></div>
              <Form.Group className="mb-3" controlId="categoryName">
                <Form.Label>Display Name</Form.Label>
                <input {...register("categoryName", { required: true })} /><br/>
                {errors.categoryName && <div className="error" >Display Name is required</div>}
              </Form.Group>

      
      </Modal.Body>      
              <Modal.Footer>
                <Button variant="secondary" onClick={modalClose}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit(onSubmit)} type="submit">
                  Update Display Name
                </Button>
              </Modal.Footer>
      
    </Form>  
    </Modal>
  );
};

export default CategoryModal; 